module.exports = __webpack_public_path__ + "img/number.5f565c17.png";